"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-719c9368"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = { class: "execute-info local-main-page" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_1.createElementVNode)("div", { class: "execute-info-title" }, "诉讼信息", -1));
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LogInfo = (0, vue_1.resolveComponent)("LogInfo");
    const _component_FlowEdit = (0, vue_1.resolveComponent)("FlowEdit");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.litigationRecordId)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                _hoisted_3,
                (0, vue_1.createVNode)(_component_LogInfo, { id: _ctx.litigationRecordId }, null, 8, ["id"])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_FlowEdit, {
            ref: "flow-edit",
            mainData: _ctx.mainData,
            flow: _ctx.flow.data,
            refuse: _ctx.flow.key === 'ufo_cs_zx_20',
            disabled: _ctx.isFinished,
            payload: { id: _ctx.currentParams.flowId },
            onBack: _ctx.onBack
        }, null, 8, ["mainData", "flow", "refuse", "disabled", "payload", "onBack"])
    ]));
}
exports.render = render;
